/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  getPaymentDetails,
  updatePaymentDetails,
  createPaymentDetails,
  deletePaymentDetails,
} from '~/api/paymentDetails';

import { Terminal } from '~/types/index';
import { paymentDetails } from '~/routes';
import {
  useDeleteMutation,
  useEditMutation,
  usePageQuery,
  useCreateMutation,
} from './usePageQuery';

export const usePaymentDetailsQuery = (options?: any) => {
  return usePageQuery<Terminal[]>(paymentDetails, getPaymentDetails, options);
};

export const usePaymentDetailsEdit = (closeParent?: () => void) => {
  return useEditMutation(paymentDetails, updatePaymentDetails, {
    onMutate: closeParent,
  });
};

export const usePaymentDetailsCreate = (closeParent: () => void) => {
  return useCreateMutation(paymentDetails, createPaymentDetails, {
    onMutate: closeParent,
  });
};

export const usePaymentDetailsDelete = (closeParent: () => void) => {
  return useDeleteMutation(paymentDetails, deletePaymentDetails, {
    onMutate: closeParent,
  });
};
